import React, { useState } from 'react';
import './Header.css'; 
import { NavLink } from 'react-router-dom';
import { FaSpotify, FaYoutube } from "react-icons/fa";
import { RiInstagramFill } from "react-icons/ri";
import { IoClose } from 'react-icons/io5';
import { FiAlignJustify } from "react-icons/fi";

const Header = () => {

  const [isMenuVisible, setIsMenuVisible] = useState(false);

  return (
    <>
      <div className='desktop-bar'>
        <DesktopBar />
      </div>

      <div className='mobile-bar'>
        {isMenuVisible ? (
          <MobileMenu setIsMenuVisible={setIsMenuVisible} />
        ) : (
          <CollapsedMobileMenu setIsMenuVisible={setIsMenuVisible} />
        )}
      </div>
    </>
  );
};


function DesktopBar() {

  return (
    <div className="wrapper">
      <nav className="barra-navegacao">
        <LeftBar />
        <RightBar />
      </nav>
    </div>
  );
}

function MobileMenu({ setIsMenuVisible }) {

  return (
    <div className="invisible-header">
      <IoClose
        id="close"
        aria-label= 'close menu' 
        onClick={() => setIsMenuVisible(false)}
      />

      <nav>
        <ul className = 'pages-list'>
          <li><NavLink to="/agenda" onClick={() => setIsMenuVisible(false)} >AGENDA</NavLink></li>
          <li><NavLink to="/contato" onClick={() => setIsMenuVisible(false)}>CONTATO</NavLink></li>
          <li><NavLink to="/musicas" onClick={() => setIsMenuVisible(false)} >MÚSICAS</NavLink></li>
          <li><NavLink to="/historia" onClick={() => setIsMenuVisible(false)}>HISTÓRIA</NavLink></li>
        </ul>
        {getSocialMediaIcons('')}
      </nav>
    </div>
  );
}

function CollapsedMobileMenu({ setIsMenuVisible }) {

  return (
    <div>
      <nav className="mobile-header">
        <ul>
          <li style={{padding:'10px', fontFamily:'pine-forest', fontSize: '40px'}} >
            <NavLink style={{ color:'#783E19'}} to="/" > MARACAJU</NavLink>
          </li>
          <li style={{padding:'10px'}}>
          <button
            aria-label="open menu"
            className="menu-toggle"
            onClick={() => setIsMenuVisible(true)}
          >
            <FiAlignJustify size={30} />
          </button>
          </li>
        </ul>
      </nav>
    </div>
  );
}

function LeftBar() {

  return (
    <ul>
      <li style={{fontFamily:'pine-forest' , fontSize: '40px'}}>
        <NavLink to="/"> MARACAJU</NavLink>
      </li>
    </ul>
  );
}

function RightBar() {

  return (
    <ul>
      <li><NavLink to="/agenda">Agenda</NavLink></li>
      <li><NavLink to="/contato">Contato</NavLink></li>
      <li><NavLink to="/musicas">Músicas</NavLink></li>
      <li><NavLink to="/historia">História</NavLink></li>
      <li><div className="header-divider" /></li>
      {getSocialMediaIcons('icons')}
    </ul>
  );
}

function getSocialMediaIcons(className) {
  
  const instagram_link = "https://www.instagram.com/maracajudegaveta/";
  const yt_link = "https://www.youtube.com/@Maracajudegaveta";
  const sptf_link = "https://open.spotify.com/intl-pt/artist/3LtAa0gp7mQCPEcbyFs8nd?trackId=1CKfCj9izL24zGTrO6QTFE"
  
  return (
    <ul>
      <li>
        <a
          href= {instagram_link}
          target="_blank"
          rel="noreferrer"
        >
          <RiInstagramFill className={className} size={30} />
        </a>
      </li>
      <li>
        <a
          href= {yt_link}
          target="_blank"
          rel="noreferrer"
        >
          <FaYoutube className={className} size={30} />
        </a>
      </li>
      <li>
        <a
          href= {sptf_link}
          target="_blank"
          rel="noreferrer"
        >
          <FaSpotify className={className} size={30} />
        </a>
      </li>
    </ul>
  );
}

export default Header;
